import { useCallback } from 'react';

import useVersionInfo from 'hooks/useVersionInfo';

import { DatasetRef } from './types';

/**
 * Builds a DatasetRef for a dataset in the release currently in the URL. Search results are always
 * route-scoped, so this saves those call sites from assembling the release by hand.
 */
export const useRouteDatasetRef = (): ((id: string | number) => DatasetRef) => {
  const { ver, system_model } = useVersionInfo();

  return useCallback(
    (id: string | number) => ({ id: String(id), version: ver, systemModel: system_model }),
    [ver, system_model]
  );
};
